module.exports = __webpack_public_path__ + "images/category_lp/alcohol/store_images/4_3498aceced13fe9714acbb3daf3cf532.png";